export default __webpack_public_path__ + "static/media/electrical-vehicle-charging-station.inline.c3b9e617.svg";